import { usePage } from "@inertiajs/react";
import { DefaultLayoutWrapper } from "layouts/DefaultLayout";
import Container from "hardcover-ui/components/Container";
import ProfileWrapper from "components/profile/ProfileWrapper";
import { UserActivityPageProps } from "./show.props";
import Activity from "components/feed/Activity";
import ActivityType from "types/ActivityType";
import { BackLink } from "components/ui";

function UserActivitiesShowPage() {
  const { user, activity } = usePage<UserActivityPageProps>().props;

  return (
    <ProfileWrapper user={user}>
      <Container size="lg">
        <BackLink url={`/@${user.username}/activity`} message="All Activities" />
        <Activity activity={activity as ActivityType}/>
      </Container>
    </ProfileWrapper>
  );
}

UserActivitiesShowPage.layout = DefaultLayoutWrapper;
export default UserActivitiesShowPage;